import PaddockAvatar from '@/components/ui/paddock-avatar/paddock-avatar';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import getCallMeBy from '@/components/user/get-call-me-by';
import type { User } from '@/models/registry';
import ProfileCard from './profile-card';

const UserProfileCard = ({
  user,
  withAvatar = false,
}: {
  user: User;
  withAvatar?: boolean;
}) => {
  return (
    <Tooltip delayDuration={500}>
      <TooltipTrigger asChild>
        <div className="flex flex-row gap-1 items-center text-xs  text-black text-nowrap">
          {withAvatar ? (
            <PaddockAvatar
              src={user.avatar}
              alt={`${user.first_name} ${user.last_name}`}
              fallback={`${user.first_name.charAt(0)} ${user.last_name.charAt(0)}`}
            />
          ) : null}
          {getCallMeBy(user)}
        </div>
      </TooltipTrigger>
      <TooltipContent className="flex flex-row gap-1 items-center bg-white rounded px-2 py-2 border border-slate-300 z-50 text-xs">
        <ProfileCard user={user} />
      </TooltipContent>
    </Tooltip>
  );
};

export default UserProfileCard;
